import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V4 } from '@studio/constants/env-variables';
import type { SocialMediaAccounts } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    url: `${CENTRAL_API_V4}/customers/@customerId/socialmedia`,
    request: {} as SocialMediaAccounts.Post.V4.AuthCodePayload | SocialMediaAccounts.Post.V4.TokenPayload,
  },
};

export const id = {
  [HTTP_METHODS.PUT]: {
    method: HTTP_METHODS.PUT,
    url: `${CENTRAL_API_V4}/customers/@customerId/socialmedia/@id`,
    params: {} as { id: string },
    request: {} as SocialMediaAccounts.Put.V4.AuthCodePayload | SocialMediaAccounts.Put.V4.TokenPayload,
  },
};
